import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    TabsCounterColorsConstantType,
    TabsCounterDynamicStyleType,
    TabsCounterColors
} from "./type";
import type {
    Mutable
} from "../../../../types";

export const getTabsCounterColors = ({
    isDisabled,
    isSelected,
    countType,
    variant,
    colors
}: TabsCounterColorsConstantType): TabsCounterColors => {
    const type = isSelected ? "neutral" : countType;

    const isStrongNeutral = variant === "segment" && !isSelected && !isDisabled && type === "neutral";

    return {
        customColor: isStrongNeutral ? colors.system.container.neutral : undefined,
        type
    };
};

const stylesheet = StyleSheet.create({
    chip: {
        justifyContent: "center",
        borderStyle: "solid",
        alignItems: "center",
        maxWidth: "100%"
    },
    title: {
        textAlign: "center",
        fontVariant: [
            "tabular-nums"
        ],
        flexShrink: 1
    }
});

export const useStyles = ({
    containerColor,
    shapeConfigs,
    borderColor,
    iconSizes,
    radiuses,
    borders
}: TabsCounterDynamicStyleType) => {
    const styles = {
        chip: {
            paddingHorizontal: iconSizes.small / 2 - shapeConfigs.chipPaddingOffset,
            backgroundColor: containerColor,
            borderRadius: radiuses.chip,
            minHeight: iconSizes.small,
            minWidth: iconSizes.small,
            borderWidth: borders.line,
            borderColor
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
